module.exports = __webpack_public_path__ + "img/public-cc-banner.0cabef22.png";